import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import FiftyFiftyServicesItemImageLeft from './FiftyFiftyServicesItemImageLeft';
import FiftyFiftyServicesItemImageRight from './FiftyFiftyServicesItemImageRight';

const FiftyFiftyServices = ({blok}) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div id="our-journey" className="lg:py-20 py-12">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="flex flex-col items-center border-b">
                        <img src={blok?.logo?.filename} alt={blok?.logo?.alt} className="w-10 h-10 mb-5 lg:mb-7" />
                        <div className="label text-orange mb-2.5">
                            {blok?.label}
                        </div>
                        <div className="h2 text-midnight mb-8 lg:mb-10">
                            {blok?.title}
                        </div>
                    </div>
                    <div className="mt-10 lg:mt-24 grid grid-col-1 gap-14 lg:gap-24">
                    {blok?.items?.map((item, index) => (
                        (index + 1) % 2 === 0
                            ? <FiftyFiftyServicesItemImageRight {...item} index={index} />
                            : <FiftyFiftyServicesItemImageLeft {...item} index={index} />
                        ))}

                    </div>
                </div>
            </div>
        </SbEditable>
      );
  };

export default FiftyFiftyServices
  